import { useCallback } from 'react';
import { useInteractionParams } from 'src/common/hooks/useInteractionParams';
import { plural } from 'src/common/utils/string';
import { useInteraction } from '@/common/hooks/useInteraction';

/**
 * Hook to set the common metrics sent in payload
 * to be tracked
 */
export const useInteractionMetrics = (options?: Record<string, unknown>) => {
  const { interactionId, interactionType } = useInteractionParams();

  const { data: interaction } = useInteraction(interactionId, interactionType);

  const createPayload = useCallback(
    () =>
      ({
        interactionId,
        interactionType,
        ...(interaction
          ? {
              id: interactionId,
              interactionStatus: interaction.status,
              type: interactionType ? plural(interactionType) : null,
              city: interaction.property?.city,
              county: interaction.property?.county,
              state: interaction.property?.state,
              street1: interaction.property?.street1,
              street2: interaction.property?.street2,
              zip: interaction.property?.zip,
            }
          : {}),
        ...options,
      }) as Record<string, unknown>,
    [interactionId, interactionType, interaction, options],
  );

  return createPayload;
};
